import React, { Component } from 'react'
import { DragSource } from 'react-dnd';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ModulePreview from './ModulePreview';

/* drag sources */
const itemSource = {
    beginDrag(props) {
        return props.item;
    },
    endDrag(props, monitor, component) {
        if (!monitor.didDrop()) {
            return;
        }
        let target = monitor.getDropResult()
        props.checkOverwrite(props.item, target.week, target.day, props.course_id, target.dayValue)
        return true
    }
}

function collectSource(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    };
}

class DraggableModule extends Component {
    
    render() {
        let { connectDragSource, isDragging, modulePreviewData } = this.props;
        // console.log(modulePreviewData)
        if (this.props.alreadySelected) {
            return (
                <div style={{ opacity: isDragging ? 0.5 : 1 }}>
                    <ExpansionPanel style={{ backgroundColor: this.props.alreadySelected ? '#DDDDDD' : 'white' }} onChange={() => this.props.onExpand(this.props.item.module_id)}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>{this.props.item.ModuleName}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            {/* <Typography> */}
                                <ModulePreview lessons={modulePreviewData} maxWeeks={4}/>
                            {/* </Typography> */}
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
            )
        }

        return (
            connectDragSource(
                <div style={{ opacity: isDragging ? 0.5 : 1 }}>
                    <ExpansionPanel style={{ backgroundColor: this.props.alreadySelected ? '#DDDDDD' : 'white' }} onChange={() => this.props.onExpand(this.props.item.module_id)}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>{this.props.item.ModuleName}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            {/* <Typography> */}
                                <ModulePreview lessons={modulePreviewData} maxWeeks={4}/>
                            {/* </Typography> */}
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>)
        );
    }
}

export default DragSource('item', itemSource, collectSource)(DraggableModule);


// WEBPACK FOOTER //
// src/main/content/course/scheduleComponents/DraggableModule.js